import styled from '@emotion/styled';
import { ob, shimmer } from '../../onboardingV2.tokens';

export const Card = styled.div`
    padding: 16px;
    border: 1px solid ${ob.color.borderSubtle};
    border-radius: ${ob.radius.lg};
    background: ${ob.color.surface};
    box-shadow: ${ob.shadow.raised};
    text-align: left;
`;

export const Head = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const Avatar = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: ${ob.color.lime100};
    color: ${ob.color.brand};
    font-family: ${ob.font.heading};
    font-size: 20px;
    font-weight: 700;
    text-transform: uppercase;
`;

export const NameBlock = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const Name = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 17px;
    font-weight: 700;
    color: ${ob.color.brand};
`;

export const Status = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 2px;
    font-size: 13px;
    font-weight: 600;
    color: ${ob.color.success};

    &::before {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${ob.color.successDot};
    }
`;

export const UrlRow = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    min-height: ${ob.tap};
    margin-top: 14px;
    padding-left: 12px;
    border-radius: ${ob.radius.md};
    background: ${ob.color.subtle};
    border: 1px solid ${ob.color.borderSubtle};

    > i {
        flex-shrink: 0;
        font-size: 16px;
        color: ${ob.color.muted};
    }
`;

export const Url = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: ${ob.color.body};
`;

export const CopyButton = styled.button`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-height: ${ob.tap};
    padding: 0 12px;
    border: 0;
    border-radius: ${ob.radius.md};
    background: transparent;
    font-family: ${ob.font.body};
    font-size: 14px;
    font-weight: 700;
    color: ${ob.color.brand};
    cursor: pointer;

    i {
        font-size: 18px;
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }
`;

export const Divider = styled.hr`
    margin: 14px 0 12px;
    border: 0;
    border-top: 1px solid ${ob.color.borderSubtle};
`;

export const Product = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
`;

export const ProductThumb = styled.span`
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: ${ob.radius.sm};
    overflow: hidden;
    background: ${ob.color.subtle};
    border: 1px solid ${ob.color.borderSubtle};
    color: ${ob.color.muted};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    i {
        font-size: 22px;
    }
`;

export const ProductText = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
`;

export const ProductName = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 15px;
    font-weight: 600;
    color: ${ob.color.text};
`;

export const ProductPrice = styled.span`
    font-size: 14px;
    color: ${ob.color.muted};
    font-variant-numeric: tabular-nums;
`;

export const Skeleton = styled.span`
    display: block;
    width: ${({ w }) => w || '100%'};
    height: ${({ h }) => h || '14px'};
    border-radius: ${({ round }) => (round ? '50%' : '8px')};
    background: ${ob.color.skeleton};
    background-image: linear-gradient(
        90deg,
        ${ob.color.skeleton} 0px,
        #f8f9fa 60px,
        ${ob.color.skeleton} 120px
    );
    background-size: 400px 100%;
    animation: ${shimmer} 1.2s linear infinite;

    ${ob.reducedMotion} {
        animation: none;
    }
`;
